.item {
  flex-direction: column;
  align-items: flex-start;
}

.description {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
  white-space: normal;
}
